export const IZIN_ORDER = [
  "CPIB",
  "CBIB",
  "CPPIB",
  "CPOIB",
  "KAPAL",
  "CDOIB"
];